import tmhRequest from '@/config/tmhRequest'

export default {
    searchMyCoupon: function (data) {
        return tmhRequest({
            url: '/customer/tmh/mycoupon/searchmycoupon',
            method: 'post',
            params: data,
        })
    },

    searchListMyCoupon: function (data) {
        return tmhRequest({
            url: '/customer/tmh/mycoupon/searchlistmycoupon',
            method: 'post',
            params: data,
        })
    },

    sendMyCoupon: function (data) {
        return tmhRequest({
            url: '/customer/tmh/mycoupon/sendmycoupon',
            method: 'post',
            data: data,
        })
    },

    delayMyCoupon: function (data) {
        return tmhRequest({
            url: '/customer/tmh/mycoupon/delaymycoupon',
            method: 'post',
            params: data,
        })
    },

    linkMyCoupon: function (data) {
        return tmhRequest({
            url: '/customer/tmh/mycoupon/linkmycoupon',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/customer/mycoupon.js